var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "ol",
    {
      staticClass: "wrapper stack",
      style: {
        justifyItems:
          _vm.horizontal === "left"
            ? "start"
            : _vm.horizontal === "center"
            ? "center"
            : "end",
        alignItems: _vm.vertical === "top" ? "start" : "end",
      },
    },
    _vm._l(_vm.items, function (item, i) {
      return _c(
        "li",
        {
          key: item.id,
          staticClass: "item",
          class: [
            `align-${_vm.horizontal}`,
            `justify-${_vm.vertical}`,
            _vm.color,
          ],
          style: {
            translate: `${i * _setup.offsetX}px ${i * _setup.offsetY}px`,
            scale: `${_setup.props.horizontal === "center" ? 1 - i * 0.05 : 1}`,
            opacity: `${1 - i * 0.35}`,
            pointerEvents: i === 0 ? "auto" : "none",
            zIndex: _vm.items.length - i,
          },
          on: {
            click: () => {
              _setup.clear(item.id)
              _setup.time.reset()
            },
            mouseenter: _setup.time.stop,
            mouseleave: _setup.time.start,
          },
        },
        [
          _vm._v(" " + _vm._s(item.message) + " "),
          i === 0
            ? _c("div", {
                staticClass: "progress-bar",
                style: { width: _setup.progressWidth },
              })
            : _vm._e(),
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }